import { render, staticRenderFns } from "./ResourceCard.vue?vue&type=template&id=6a55137c&scoped=true&"
import script from "./ResourceCard.vue?vue&type=script&lang=js&"
export * from "./ResourceCard.vue?vue&type=script&lang=js&"
import style0 from "./ResourceCard.vue?vue&type=style&index=0&id=6a55137c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a55137c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/staging.portal.letsreimagine.org/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a55137c')) {
      api.createRecord('6a55137c', component.options)
    } else {
      api.reload('6a55137c', component.options)
    }
    module.hot.accept("./ResourceCard.vue?vue&type=template&id=6a55137c&scoped=true&", function () {
      api.rerender('6a55137c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/home/components/resources/ResourceCard.vue"
export default component.exports